import { render } from "./HospitalAdManage.vue?vue&type=template&id=9ea6bc9e&scoped=true"
import script from "./HospitalAdManage.vue?vue&type=script&lang=js"
export * from "./HospitalAdManage.vue?vue&type=script&lang=js"

import "./HospitalAdManage.vue?vue&type=style&index=0&id=9ea6bc9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ea6bc9e"]])

export default __exports__